import { __extends } from "tslib";
import { ContentElement } from './ContentElement';
var TextElement = /** @class */ (function (_super) {
    __extends(TextElement, _super);
    function TextElement(text, elementFormat, eventMirror, textRotation) {
        if (text === void 0) { text = null; }
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this, elementFormat, eventMirror, textRotation) || this;
        _this._text = text;
        //this._rawText = text;
        console.warn('[TextElement]', elementFormat);
        return _this;
    }
    Object.defineProperty(TextElement.prototype, "text", {
        get: function () {
            //console.warn('[ContentElement] - get text not implemented');
            return this._text;
        },
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _text: string;
        set: function (value) {
            //console.warn('[TextElement] - set text not implemented');
            this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    TextElement.prototype.replaceText = function (beginIndex /*int*/, endIndex /*int*/, newText) {
        this._rawText = this._text.slice(0, beginIndex) + newText + this._text.slice(endIndex, this._text.length - 1);
        this._text = this._rawText;
    };
    TextElement.forceNativeConstructor = true;
    TextElement.forceNativeMethods = true;
    return TextElement;
}(ContentElement));
export { TextElement };
